import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';

export default function useEffectiveMake(): string {
  const { customizeOptions, trims, truckBodyStyles } =
    useContext(ParentModelContext);

  const customizedTrim = customizeOptions.data;
  const truckBodyStyleData = truckBodyStyles.data;

  return customizedTrim.make || truckBodyStyleData.make || trims.data.make;
}
